import React from 'react'

import HintPopover from "../../../gd-ui/hint-popover/hint-popover"
import getDocumentIcon from "./functions/get-document-icon"

type Props = {
    className?  : any

    size?       : '12' | '13' | '14'
    noteTypeId  : string

    hint?       : boolean

    onClick?    : func
}

export default class DocumentIcon extends React.Component<Props> {

    static defaultProps = {
        size: '13',
        hint: false
    }

    render() {

        const noteType = gd.session.noteTypes.get(this.props.noteTypeId)
        const icon = getDocumentIcon(this.props.noteTypeId)

        const classes = Classes("ui5-ico-"+this.props.size, icon, this.props.className)

        return (
            <div className={classes} onClick={this.props.onClick}>
                {noteType && this.props.hint && <HintPopover hint={noteType.name}/>}
            </div>
        );
    }
}